import angular from 'angular'
import uiRouter from 'angular-ui-router'
import ngMessages from 'angular-messages'

import AppConfig from '../../src-generated/app.config'
import Common from './common'
import Pages from './pages'
import Services from './services'

import component from './app.component'

angular.module('app', [
  uiRouter,
  ngMessages,
  AppConfig,
  Common,
  Pages,
  Services
])

// Directive to use a fallback source when an image fails to load while complying with CSP policies
.directive('fallbackSrc', function () {
  return {
    link: function postLink (scope, iElement, iAttrs) {
      iElement.bind('error', function () {
        angular.element(this).attr('src', iAttrs.fallbackSrc)
      })
    }
  }
})

.config(($locationProvider, $httpProvider, $qProvider, $sceDelegateProvider) => {
  'ngInject'
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode
  $locationProvider.html5Mode(true).hashPrefix('!')

  // Add API interceptor
  $httpProvider.interceptors.push('ApiInterceptor')

  $qProvider.errorOnUnhandledRejections(false)

  $sceDelegateProvider.resourceUrlWhitelist([
    'self', // Allow same origin resource loads.
    'https://www.youtube.com/**' // Allow loading from our assets domain.
  ])
})

.run(($log, $transitions, Localization, StoreTypes) => {
  'ngInject'

  if (Localization.getLocalizedAppConfig().type !== StoreTypes.STANDALONE) {
    $log.info('R-LINK Store embedded in an iframe...')
    require('./iframe.js')(Localization.getLocalizedAppConfig().rootUrl)
  }

  let redirectToAuthentication = (trans) => {
    $log.info('User isn\'t authenticated! Redirecting...')
    return trans.router.stateService.target('authentication')
  }

  $transitions.onStart(
    {to: (state) => state.authenticate},
    (trans) => {
      $log.debug('Restricted page. Checking authentication...')
      const userService = trans.injector().get('UserService')
      const myRenaultResolver = trans.injector().get('MyRenaultResolver')
      if (myRenaultResolver.isMyRenault()) {
        $log.debug('Helios, One or MyRenault website. Checking token...')
        return Promise.resolve()
      } else {
        $log.debug('Standalone or RSite website. Fetching current user...')
        if (userService.getCurrentToken()) {
          return userService.getCurrentUser()
          .then((user) => {
            $log.debug('User found: ', user)
            if (!user) {
              return redirectToAuthentication(trans)
            } else {
              // password expired
              if (userService.isPasswordExpired(user.lastPasswordUpdate,
                Localization.getLocalizedAppConfig().passwordExpirationDay) &&
                trans.targetState().identifier() !== 'changePassword') {
                // Redirect to the change password page
                return trans.router.stateService.target('changePassword')
              }
            }
          })
        } else {
          return redirectToAuthentication(trans)
        }
      }
    }
  )

  $transitions.onStart(
    {to: (state) => state.authenticatedForbidden},
    (trans) => {
      $log.debug('Page forbidden if authenticated. Checking authentication...')
      const userService = trans.injector().get('UserService')
      const vehicleService = trans.injector().get('VehicleService')
      const myRenaultResolver = trans.injector().get('MyRenaultResolver')
      if (myRenaultResolver.isMyRenault()) {
        $log.debug('Helios, One or MyRenault website. Not concerned...')
        return Promise.resolve()
      } else {
        $log.debug('Standalone or RSite website. Fetching current user...')
        if (userService.getCurrentToken()) {
          return userService.getCurrentUser()
          .then((user) => {
            if (user) {
              // password expired
              if (userService.isPasswordExpired(user.lastPasswordUpdate, Localization.getLocalizedAppConfig().passwordExpirationDay)) {
                // Redirect to the change password page
                return trans.router.stateService.target('changePassword')
              } else {
                // Redirect to the catalog page
                return vehicleService.getCurrentSelectedVehicle()
                .then((vehicle) => {
                  $log.info('User is authenticated! Redirecting...')
                  if (vehicle) {
                    return trans.router.stateService.target('vehicle', {vin: vehicle.vin, sync: true})
                  }
                  return trans.router.stateService.target('profile')
                })
              }
            }
          })
        }
      }
    }
  )
})

.component('app', component)



// WEBPACK FOOTER //
// ./src/app/app.js